<app-modal-base
  [title]="'youOwnThisDomain' | translate"
  [showCloseIcon]="true"
  [primaryButtonText]="'yes' | translate"
  [secondaryButtonText]="'no' | translate"
  (close)="dialogRef.close(false)"
  (primaryClick)="dialogRef.close(true)"
  (secondaryClick)="dialogRef.close(false)"
>
  <p class="text-black">
    {{ 'areYouTheOwnerOf' | translate }} <span class="font-bold">{{ data.domain }}</span>
  </p>
</app-modal-base>
